module.exports = __webpack_public_path__ + "img/top_slider_ecoproject05.c2422304.jpg";